// amazon-cognito-identity-js does `import * as Cookies from 'js-cookie'` and
// calls Cookies.set / Cookies.get / Cookies.remove. js-cookie 3 only has a
// default export, so those names have to be re-exported for that import.
import api from '../../node_modules/js-cookie/dist/js.cookie.mjs';

export const set = (...args) => api.set(...args);
export const get = (...args) => api.get(...args);
export const remove = (...args) => api.remove(...args);

export default api;
